<template>
    <div class="view view__module_iframe_scorm">
        <module-iframe-scorm></module-iframe-scorm>
    </div>
</template>

<script>
import ModuleIframeScorm from '@/components/ebs/modules/iframe/ModuleIframeScorm'
export default {
  name: 'view-module-iframe-scorm',
  components: { ModuleIframeScorm },
  computed: {
    routeFileId () {
      return this.$route.params.id
    }
  },
  methods: {
    getFile () {
      this.$store.dispatch('ebsModuleGetSCORMFile', this.routeFileId)
    }
  },
  mounted () {
    this.getFile()
  }
}
</script>
